import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import { useFormikContext, getIn, Formik, Form } from 'formik';
import * as Yup from 'yup';

import { Button } from 'core/components/button';
import Field from 'core/components/form/form.v2';
import BaseDialog from 'core/components/base-dialog';
import { Label } from 'core/components/label';
import useStyles from './edit-location-modal.styles';

const EditLocationModal = ({ onClose, index }) => {
  const classes = useStyles();
  const { setFieldValue, setFieldTouched, values } = useFormikContext();

  const validationSchema = Yup.object().shape({
    description: Yup.string().required('Description is required'),
    numberOfAcres: Yup.number().required('Acres is required')
  });

  const initialValues = {
    description: getIn(values, `farmLocations[${index}].description`),
    numberOfAcres: getIn(values, `farmLocations[${index}].numberOfAcres`),
    additionalLegalDescription: getIn(values, `farmLocations[${index}].additionalLegalDescription`) || null,
    locationDirections: getIn(values, `farmLocations[${index}].locationDirections`) || null
  };

  const handleSubmit = async (modalValues) => {
    setFieldValue(`farmLocations[${index}].description`, modalValues.description);
    setFieldTouched(`farmLocations[${index}].description`, true);
    setFieldValue(`farmLocations[${index}].numberOfAcres`, modalValues.numberOfAcres);
    setFieldTouched(`farmLocations[${index}].numberOfAcres`, true);
    if (modalValues.additionalLegalDescription) {
      setFieldValue(`farmLocations[${index}].additionalLegalDescription`, modalValues.additionalLegalDescription);
      setFieldTouched(`farmLocations[${index}].additionalLegalDescription`, true);
    }
    if (modalValues.locationDirections) {
      setFieldValue(`farmLocations[${index}].locationDirections`, modalValues.locationDirections);
      setFieldTouched(`farmLocations[${index}].locationDirections`, true);
    }
    onClose();
  };

  return (
    <BaseDialog className={classes.modal} onClose={onClose} open>
      <div className={classes.container}>
        <Label className={classes.mainLabel} type="green75Big">
          Modify Location
        </Label>
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
          enableReinitialize
        >
          {({ handleSubmit, isValid }) => (
            <Form>
              <Field xs={12} type="string" name="description" id="description" label="Location name" mode="light" />
              <Field xs={12} type="numeric" name="numberOfAcres" id="numberOfAcres" label="Acres" mode="light" />
              <Field
                xs={12}
                type="textarea"
                id="additionalLegalDescription"
                name="additionalLegalDescription"
                mode="light"
                label="Additional legal description (optional)"
              />
              <Field
                xs={12}
                type="textarea"
                id="locationDirections"
                name="locationDirections"
                mode="light"
                label="Location directions (optional)"
              />
              <div className={classes.buttonContainer}>
                <Button
                  variant="contained"
                  type="submit"
                  color="primary"
                  onClick={handleSubmit}
                  className={classes.buttons}
                  disabled={!isValid}
                >
                  Save changes
                </Button>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </BaseDialog>
  );
};

EditLocationModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  index: PropTypes.number
};

export default observer(EditLocationModal);
